<template>
  <div class="form-body">
    <div class="row">
      <div class="img-holder">
        <div class="bg"></div>
        <div class="info-holder">
          <h3>{{$t(`login.hook`)}}</h3>
          <p>{{$t(`login.hookDesc`)}}</p>
          <img src="img/graphic5.png" alt="">
        </div>
      </div>
      <div class="form-holder">
        <div class="form-content">
          <div class="form-items">
            <div class="website-logo-inside">
              <div class="logo">
                <img class="logo-size" src="img/logo-white.png" alt="">
              </div>
            </div>
            <div class="page-links" v-if="links">
              <router-link v-for="link in links" :key="link.href" :to="{ name: link.href }" :class="link.href === $route.name ? `active` : ``">{{link.label}}</router-link>
            </div>
            <h3 v-if="title">{{title}}</h3>
            <p v-if="desc">{{desc}}</p>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Layout",
    props: {
      links: Array,
      title: String,
      desc: String,
    },
  }
</script>

<style scoped>

</style>
